import { useRef, useState } from "react";
import PackageRequestDelete from "./package-request-delete";
import PackageRequestEdit from "./package-request-edit";
import PackageRequestList from "./package-request-list";

const PackageRequestMain = (props) => {
  const listRef = useRef(null);

  const [visibleEditorDialog, setVisibleEditorDialog] = useState(false);
  const [visibleDeleteDialog, setVisibleDeleteDialog] = useState(false);
  const [editorData, setEditorData] = useState(null);

  // handle ui event section

  const handleOnClickRowEdit = (row) => {
    setEditorData(row);
    setVisibleEditorDialog(true);
  };

  const handleOnClickRowDelete = (row) => {
    if (row.id && row.id > 0) {
      setEditorData(row);
      setVisibleDeleteDialog(true);
    }
  };

  const handleOnClickAddNew = () => {
    setEditorData({});
    setVisibleEditorDialog(true);
  };

  const handleOnConfirmedEdit = (data) => {
    listRef.current.handleOnUpdateViewRow(data);
    setVisibleEditorDialog(false);
  };

  const handleOnConfirmedDelete = (data) => {
    listRef.current.handleOnDeleteViewRow(data);
    setVisibleDeleteDialog(false);
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <PackageRequestDelete
        visible={visibleDeleteDialog}
        onHide={() => setVisibleDeleteDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedDelete}
      />

      <PackageRequestEdit
        visible={visibleEditorDialog}
        onHide={() => setVisibleEditorDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedEdit}
      />

      <PackageRequestList
        ref={listRef}
        onClickRowEdit={handleOnClickRowEdit}
        onClickRowDelete={handleOnClickRowDelete}
        onClickAddNew={handleOnClickAddNew}
      />
    </div>
  );
};

export default PackageRequestMain;
